/* eslint-disable react/jsx-no-useless-fragment */
import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import LiveOfferStatus from 'component/LiveOfferStatus/LiveOfferStatus';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import ActivityContainer from 'component/ActivityContainer/ActivityContainer';
import MessagingContainer from 'component/MessagingContainer/MessagingContainer';
import PropertyOffer from 'component/PropertyProfile/PropertyOffer';
import { postApiCall } from 'api/apiService';
import { GET_PROPERTY_INDIVIDUAL } from 'constant/app.config';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/system';
import ProfileImageDetails from 'component/PropertyProfile/ProfileImageDetails';
import PropertyDescription from 'component/PropertyProfile/PropertyDescription';
import PropertyProfileDetails from 'component/PropertyProfile/PropertyProfileDetails';
import PropertyFeature from 'component/PropertyProfile/PropertyFeature';
import PropertyProfileMortageCalculator from 'component/PropertyProfile/PropertyProfileMortageCalculator';
import PropertyVideo from 'component/PropertyProfile/PropertyVideo';
import PropertyAngleView from 'component/PropertyProfile/PropertyAngleView';
import PropertyNearBy from 'component/PropertyProfile/PropertyNearBy';
import PropertyWalkScore from 'component/PropertyProfile/PropertyWalkScore';
import PropertySpecDetails from 'component/PropertyProfile/PropertySpecDetails';

function PropertyDetailContainer() {
  const params = useParams();
  const { setLoaderConfig } = useContext(LoaderContext);
  const [profileDetails, setProfileDetails] = useState({});
  const getListInfo = async () => {
    const inputData = {
      propertyId: params?.propertyId,
    };
    setLoaderConfig({ isVisible: false });
    postApiCall(GET_PROPERTY_INDIVIDUAL, inputData).then(async (res) => {
      setLoaderConfig({ isVisible: false });
      if (res?.data?.status == '-1') {
        toast.error(res?.data?.message, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          progress: 0,
          theme: 'light',
          style: {
            fontFamily: 'Poppins', // 👈 Inline Poppins font
          },
        });
      } else {
        await setProfileDetails(res?.data);
      }
    });
  };

  useEffect(() => {
    setLoaderConfig({ isVisible: false });
    getListInfo();
  }, []);

  return (
    <Grid
      style={{
        paddingTop: '40px',
      }}
    >
      <Box>
        <Grid item xs={12}>
          <ProfileImageDetails profileDetails={profileDetails} />
        </Grid>
      </Box>
      <Grid xs={12} container sx={{ p: 3 }}>
        <Grid
          item
          xs={9}
          style={{
            paddingRight: '8px',
          }}
        >
          <PropertyOffer />
          <PropertySpecDetails />
          <PropertyDescription />
          <PropertyFeature />
          <PropertyProfileDetails />
          <PropertyProfileMortageCalculator />
          <PropertyVideo />
          <PropertyAngleView />
          <PropertyWalkScore />
          <PropertyNearBy />
        </Grid>
        <Grid item xs={3}>
          <LiveOfferStatus profileDetails={profileDetails} />
          <ActivityContainer />
          <MessagingContainer />
        </Grid>
      </Grid>
    </Grid>
  );
}

PropertyDetailContainer.propTypes = {};

export default PropertyDetailContainer;
